export const staticContent = {
  ACCOMMODATION: 'staticContent.accommodation'
}
